<template>
  <dashboard
    :dashboardService = dashboardService
  ></dashboard>
</template>

<script>
  import Dashboard from '@/components/Common/Dashboard'
  import dashboardService from '@/services/rental/dashboard'

  export default {
    components: {
      Dashboard
    },
    data () {
      return {
        dashboardService: dashboardService,
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Rental/Dashboard.vue